import React from "react";
import { Link, navigate } from "gatsby";
import { useLocation } from "@reach/router";
import { Document } from "react-pdf/dist/esm/entry.webpack";
import { Page } from "react-pdf";
import BlockContent from "./../BlockContent";
import { PdfWrapperDiv, PdfFillerDiv, PdfLeftRightDivDiv } from "./elements";

const fillString = () => {
  let out = "";
  for (let i = 0; i < 100; i++) {
    for (let j = 0; j < 10; j++) {
      out += "**********";
    }
    out += " ";
  }
  return <p>{out}</p>;
};

// const makeNumberedArray = (number) => {
//   const outArray = [];
//   for (let i = 0; i < number; i++) {
//     outArray[i] = i + 1;
//   }
//   return outArray;
// };

const PdfBlock = ({
  description,
  notes,
  pdfId,
  numberOfPages,
  title,
  showSecondColumn,
}) => {
  const [totalPages, setTotalPages] = React.useState(null);
  const [currentPage, setCurrentPage] = React.useState(0);
  const [pagesWithText, setPagesWithText] = React.useState(
    new Array(Math.max(numberOfPages, 1))
  );
  const [masterKey, setMasterKey] = React.useState(0);

  const myLocation = useLocation();
  const myPathname = myLocation.pathname;

  const setThePageTo = (x) => {
    setCurrentPage(x);
    // TODO: This is going to break if this component is inside something else!
    // could check against showSecondColumn and only do that if it's true?
    // weirdly: this doesn't break, it just changes the location hash
    navigate(`#page${x}`);
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    // console.log("this has fired! Total pages: ", numPages);
    setTotalPages(numPages);
    if (!currentPage) {
      setThePageTo(1);
    }
  };

  React.useEffect(() => {
    if (!currentPage) {
      if (myLocation.hash.indexOf("#page") > -1) {
        setCurrentPage(Number(myLocation.hash.split("#page")[1]));
      }
    }
  }, [myLocation, currentPage]);

  const pdfUrl = pdfId ? `/pdfs/${pdfId}.pdf` : null;
  // console.log("masterKey: ", masterKey);
  // console.log("total pages: ", totalPages);
  // console.log("current page: ", currentPage);
  return (
    <div>
      <p className="description">{description}</p>
      <p>
        Link to PDF ({numberOfPages} page{numberOfPages > 1 ? "s" : ""}
        ):{" "}
        <a href={pdfUrl} target="_blank" rel="noreferrer">
          {title}
        </a>
      </p>
      {pdfUrl ? (
        <div>
          <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
            {totalPages ? (
              <div
                key={`pdfset${currentPage}_${totalPages}`}
                id={`pdfset${currentPage}_${totalPages}`}
              >
                <PdfLeftRightDivDiv>
                  <PdfWrapperDiv>
                    <Page
                      pageNumber={currentPage}
                      width={800}
                      renderTextLayer={true}
                      onGetTextSuccess={(items) => {
                        const newPagesWithText = pagesWithText;
                        newPagesWithText[currentPage] = items.length > 0;
                        setMasterKey(masterKey + items.length);
                        setPagesWithText(newPagesWithText);
                      }}
                    />
                    {pagesWithText[currentPage] ? null : (
                      <PdfFillerDiv>{fillString()}</PdfFillerDiv>
                    )}
                  </PdfWrapperDiv>
                  {showSecondColumn ? (
                    <div>
                      <h3>
                        <a
                          href="/#"
                          disabled={currentPage === 1}
                          onClick={(e) => {
                            e.preventDefault();
                            if (currentPage > 1) {
                              setThePageTo(currentPage - 1);
                            }
                          }}
                        >
                          «
                        </a>{" "}
                        Page{" "}
                        <Link
                          name={`page${currentPage}`}
                          to={myPathname + `#page${currentPage}`}
                        >
                          {currentPage}
                        </Link>{" "}
                        of {totalPages || ". . ."}{" "}
                        <a
                          href="/#"
                          disabled={currentPage === totalPages}
                          onClick={(e) => {
                            e.preventDefault();
                            if (currentPage < totalPages) {
                              setThePageTo(currentPage + 1);
                            }
                          }}
                        >
                          »
                        </a>
                      </h3>
                      <p>Select by dragging to annotate with Hypothesis.</p>
                      {pagesWithText[currentPage] ? (
                        <div key={`${title}_${currentPage}_${masterKey}`}>
                          <p>This PDF has been OCRed</p>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </PdfLeftRightDivDiv>
                {showSecondColumn ? null : (
                  <nav>
                    <a
                      href="/#"
                      onClick={(e) => {
                        e.preventDefault();
                        if (currentPage > 1) {
                          setThePageTo(currentPage - 1);
                        }
                      }}
                    >
                      «
                    </a>{" "}
                    Page {currentPage} of {totalPages || ". . ."}{" "}
                    <a
                      href="/#"
                      onClick={(e) => {
                        e.preventDefault();
                        if (currentPage < totalPages) {
                          setThePageTo(currentPage + 1);
                        }
                      }}
                    >
                      »
                    </a>
                  </nav>
                )}
              </div>
            ) : (
              <p>Loading PDF . . .</p>
            )}
          </Document>
        </div>
      ) : null}
      {notes ? (
        <React.Fragment>
          <h2>Notes</h2>
          <BlockContent blocks={notes} />
        </React.Fragment>
      ) : null}
    </div>
  );
};

export default PdfBlock;
